<template>
    <transition name="fade">
        <div v-show="modelValue" class="fixed inset-0 z-20 overflow-hidden">
            <!-- Backdrop -->
            <div class="absolute inset-0 -z-1 bg-gray-900 bg-opacity-80"></div>

            <!-- Cancel Button -->
            <div
                class="
                    absolute
                    top-0
                    right-0
                    text-4xl
                    p-4
                    text-white
                    cursor-pointer
                    z-10
                "
                @click="cancel"
            >
                <span class="icon-np-cancel"></span>
            </div>

            <!-- Photo -->
            <div class="absolute inset-y-0 w-full flex justify-center">
                <div class="overflow-hidden flex justify-center py-20">
                    <!-- Selected Photo -->
                    <transition mode="out-in" :name="photoTransitionClass">
                        <div :key="selectedPhoto" class="flex justify-center">
                            <img
                                class="rounded-md"
                                :src="photos[selectedPhoto]"
                                :key="selectedPhoto"
                            />
                        </div>
                    </transition>
                </div>
            </div>

            <!-- Dots -->
            <div
                class="absolute bottom-10 inset-x-0 flex justify-center"
                v-if="isMultiplePhotos"
            >
                <span
                    v-for="(value, key) in photos.length"
                    :key="key"
                    class="
                        text-2xl text-white
                        m-0.5
                        cursor-pointer
                        hover:text-primary
                    "
                    :class="{
                        'text-opacity-100': key === selectedPhoto,
                        'text-opacity-10': key !== selectedPhoto,
                    }"
                    :title="key + 1 + ' of ' + photos.length"
                    @click="changePhoto(key)"
                >
                    •
                </span>
            </div>

            <!-- Previous Button -->
            <div
                class="absolute left-20 inset-y-0 flex items-center"
                v-if="isMultiplePhotos"
            >
                <div :class="buttonClasses" @click="previousPhoto">
                    <span class="icon-np-arrow-back"></span>
                </div>
            </div>

            <!-- Next Button -->
            <div
                class="absolute right-20 inset-y-0 flex items-center"
                v-if="isMultiplePhotos"
            >
                <div :class="buttonClasses" @click="nextPhoto">
                    <span class="icon-np-arrow-forward"></span>
                </div>
            </div>
        </div>
    </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.slide-from-right-leave-active,
.slide-from-right-enter-active,
.slide-from-left-leave-active,
.slide-from-left-enter-active {
    transition: 0.5s;
}
.slide-from-right-enter-from,
.slide-from-left-leave-to {
    transform: translate(100%, 0);
}
.slide-from-right-leave-to,
.slide-from-left-enter-from {
    transform: translate(-100%, 0);
}
</style>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        photos: {
            type: Array,
            default: [],
        },
        selectedPhotoIndex: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            selectedPhoto: 0,
            photoTransitionClass: "slide-from-right",
            buttonClasses: [
                "h-7",
                "w-7",
                "rounded-full",
                "flex",
                "items-center",
                "justify-center",
                "text-secondary",
                "hover:text-white",
                "bg-white",
                "hover:bg-primary",
                "transition",
                "duration-500",
                "ease-in-out",
                "cursor-pointer",
            ],
        };
    },
    watch: {
        modelValue(newValue) {
            if (newValue) {
                this.selectedPhoto = this.selectedPhotoIndex;
                document.addEventListener("keyup", this.handleKeyup);
            } else {
                document.removeEventListener("keyup", this.handleKeyup);
            }
        },
    },
    computed: {
        isMultiplePhotos() {
            return this.photos.length > 1;
        },
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        handleKeyup(event) {
            if (event.keyCode === 27) {
                // escape key
                this.cancel();
            } else if (event.keyCode === 37) {
                // left arrow
                this.previousPhoto();
            } else if (event.keyCode === 39) {
                // right arrow
                this.nextPhoto();
            }
        },
        nextPhoto() {
            this.photoTransitionClass = "slide-from-right";
            if (this.selectedPhoto + 1 < this.photos.length) {
                this.selectedPhoto++;
            } else {
                this.selectedPhoto = 0;
            }
        },
        previousPhoto() {
            this.photoTransitionClass = "slide-from-left";
            if (this.selectedPhoto > 0) {
                this.selectedPhoto--;
            } else {
                this.selectedPhoto = this.photos.length - 1;
            }
        },
        changePhoto(photoIndex) {
            this.photoTransitionClass = "slide-from-right";
            this.selectedPhoto = photoIndex;
        },
    },
};
</script>
